import JustValidate from 'just-validate';
import toastNotification from '../modules/toastNotification';
import {socialShare, toggleSocialShare} from '../modules/socialShare';
import Swiper from "swiper";
import { Navigation, Keyboard, Autoplay } from "swiper/modules";
import {setAdBannersforMobOrDesk} from '../modules/banners';

function validateCommentForm() {

    const commentForm = document.querySelector("#comment-form");
  
    const validator = new JustValidate(commentForm, {
      validateBeforeSubmitting: true,
      focusInvalidField: true,
    });
  
  
    validator
      .addField(commentForm.querySelector('[name="author"]'), [
        {
          rule: 'required',
        }
      ])
      .addField(commentForm.querySelector('[name="comment"]'), [
        {
          rule: 'required',
        }
      ])
     ;
  
    commentForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(this);
  
      if (validator.isValid) {
        let loadingContainer = document.querySelector('#comments-form .loading');
        loadingContainer.classList.remove('hidden');
        loadingContainer.style.height = document.querySelector('#comments-form .message').scrollHeight + 'px';
        loadingContainer.style.top = 'auto';

        fetch('/blogs/comments/add', {
          method: 'post',
          credentials: 'same-origin',
          mode: 'cors',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              toastNotification('Your comment has been submited. Thank you.', 'success')
            }
          
            loadingContainer.classList.add('hidden');

            document.querySelector('#comments-form [data-close-modal]').click()
          })
          .catch((error) => console.log('error', error))
      }
  
    //   validator.onSuccess((event) => {
        
    //   });
  
  
    })
  
    // return validator
}

function getComments(){
    const commentsWidget = document.querySelector('[data-widget="article-comments"]');
    const getFirstCommentsUrl = commentsWidget.dataset.searchUrl;

    let commentsContainer = document.querySelector('[data-element="search-results"]');
    
    function fetchComments(url){
        fetch(url, {
            method: 'GET',
            mode: "cors",
            credentials: "same-origin",
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            }
          })
        .then(response => response.text())
        .then(function (html) {
            //Remove old button (if it exists)
            let oldLoadMoreButton  = document.querySelector('[data-action="load-more"]');
            if(oldLoadMoreButton !== null ){
              oldLoadMoreButton.remove();
            }

            // Temporarily disable max-height to prepare for smooth effect
            commentsContainer.style.maxHeight = commentsContainer.scrollHeight + 'px';
            
            // Add new comments to the container
            commentsContainer.innerHTML += html;
            
            // Triggering a reflow to allow the animation
            void commentsContainer.offsetHeight;

            // Set max-height back to allow transition
            commentsContainer.style.maxHeight = commentsContainer.scrollHeight + 'px';
            
            let newLoadMoreButton  = document.querySelector('[data-action="load-more"]');
            
            if(newLoadMoreButton !== null ){
              newLoadMoreButton.addEventListener('click', function (event) {
                    let url = event.target.dataset.url;
                    fetchComments(url);
                });
            }
        });
    }
    
    //Load first 3 comments
    fetchComments(getFirstCommentsUrl);
}

function likeDislike(){
  const article =  document.querySelector('[data-widget="like"]').dataset.article;

  if(localStorage.getItem(article) ==  undefined){ //if user never liked attach  event listeners to both buttons
      document.querySelectorAll('[data-action="like-article"]').forEach(field => {
          field.addEventListener('click', handleClick, {'once': true});
      })
  }else{ //if user has liked mark his
      document.querySelectorAll('[data-action="like-article"]').forEach(field => {
          field.classList.add("disabled");    
       })

       document.querySelector('[data-action="like-article"][data-value="' + localStorage.getItem(article) + '"]').classList.add("active");
  }

  function handleClick(event) {
      let field = event.target.closest(".like-icon");

      const formData = new FormData();
      formData.append('value', field.dataset.value);
      formData.append('article', field.dataset.article);

      fetch('/blogs/articles/like', {
          method: 'POST',
          mode: "cors",
          credentials: "same-origin",
          headers: {
          'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData
      })
      .then(response => response.json())
      .then(function (data) {
          if (data.status && data.message != "") {
              toastNotification(data.message, 'success');
          }
          if (!data.status && data.message != "") {
              toastNotification(data.message, 'error');
          }
          //mark button as clicked
          field.classList.add("active");

          //disable both like and dislike buttons
          document.querySelectorAll('[data-action="like-article"]').forEach(f => {
              if(f != field){ // remove the eventlisener for the other button
                  f.removeEventListener('click', handleClick);
              }
              f.classList.add("disabled"); // add class for both buttons
          })

          //save info in localsotorage
          localStorage.setItem(field.dataset.article, field.dataset.value);
      })

  }
}

function showHideTOC(){
  const accordeon = document.querySelector('.toggle-accordeon');
  const toc = document.querySelector('.blog-article-toc');

  if (accordeon && toc) {
      const img = accordeon.querySelector('img');

      // Attach click event listener to .accordeon
      accordeon.addEventListener('click', () => {
          // Toggle visibility of .blog-article-toc with a smooth animation
          if (toc.style.display === 'none' || toc.style.display === '') {
              toc.style.display = 'block';
              toc.style.opacity = 0;
              toc.style.transition = 'opacity 1.5s';
              img.style.transform =  'rotate(0deg)';

              requestAnimationFrame(() => {
                  toc.style.opacity = 1;
              });
          } else {
              toc.style.transition = 'opacity 1s';
              toc.style.opacity = 0;
              setTimeout(() => {
                  toc.style.display = 'none';
                  img.style.transform =  'rotate(180deg)';
              }, 1000);
          }
      });
  }
}

function showHideSmallTOC(){
  const accordeon = document.querySelector('.toggle-small-accordeon');
  const toc = document.querySelector('.blog-article-small-toc');

  if (accordeon && toc) {
      // Attach click event listener to .accordeon
      accordeon.addEventListener('click', (e) => {
          e.preventDefault();
          accordeon.style.display = 'none'; // Hide the toggle button after click
          
          // Toggle visibility of .blog-article-small-toc with a smooth animation
          if (toc.style.display === 'none' || toc.style.display === '') {
              toc.style.display = 'block';
              toc.style.opacity = 0;
              toc.style.transition = 'opacity 1.5s';

              requestAnimationFrame(() => {
                  toc.style.opacity = 1;
              });
          } 
      });
  }
}


function schoolslider() {
    const schoolsContainer = document.querySelector(
        '[data-module="schools-slider"]'
    );

    if (schoolsContainer) {
        const schoolsConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                // when window width is >= 1200px
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 25,
                },
            },
            navigation: {
                nextEl: '[data-module="schools-slider"] .unm-slider-btn-next',
                prevEl: '[data-module="schools-slider"] .unm-slider-btn-prev',
            },
            watchOverflow: true,
        };

        const schoolsSwiper = new Swiper(
            '[data-module="schools-slider"] .swiper',
            schoolsConfig
        );
        return schoolsSwiper;
    }
}

document.addEventListener('DOMContentLoaded', (e) => {
    validateCommentForm();
    getComments();
    //likeDislike();
    showHideTOC();
    showHideSmallTOC();
    socialShare();
    toggleSocialShare();
    schoolslider();
    setAdBannersforMobOrDesk();
})